var map = {
	"./header-error.html": 87,
	"./header-jormat.html": 88,
	"./header-parvulo.html": 89
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;



//////////////////
// WEBPACK FOOTER
// ./src/layout ^\.\/header\-.*\.html$
// module id = 86
// module chunks = 0